import { memo } from "react"
import { NavLink } from "react-router-dom"
import { noop, toLower } from "lodash"
import classNames from "classnames"
import type { PortfolioNavExpandedLink } from "../../navigation"

export interface PortfolioNavLinkProps {
  link: PortfolioNavExpandedLink
  onSaveLastLocation?: (id: string) => void
}

const PortfolioNavLink = memo(function PortfolioNavLink({ link, onSaveLastLocation = noop }: PortfolioNavLinkProps) {
  const IconComponent = link.Icon

  function handleClick() {
    onSaveLastLocation(link.id)
  }

  return <NavLink onClick={link.openInNewTab ? undefined : handleClick} data-test-class={`nav-${toLower(link.label)}`} className={({ isActive }) => classNames("link", { active: isActive })} to={link.to} {...(link.openInNewTab ? { target: "_blank", rel: "noreferrer noopener" } : {})}>
    {IconComponent
      ? <IconComponent className="nav-link-mui-icon" fontSize="small" />
      : <i className={`fa fa-${link.icon}`} />}
    {link.label}
  </NavLink>
})

export default PortfolioNavLink
